import tippy from 'tippy.js';
// import {hideAll} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { addMembersFromMenu, createGroupChatFromMenu, getAvailableParticipantsToChat } from './functions';
import { chat } from '../../libs/roomnew';
import { debounce } from '../base/video-quality/actions';
// import { debounce } from '../base/video-quality/actions';
const AVATAR_ICON = `<svg width="24" height="24" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2154_528)">
<path d="M18 35.4375C27.6305 35.4375 35.4375 27.6305 35.4375 18C35.4375 8.36953 27.6305 0.5625 18 0.5625C8.36953 0.5625 0.5625 8.36953 0.5625 18C0.5625 27.6305 8.36953 35.4375 18 35.4375Z" fill="#CCD7FA"/>
<path d="M31.9933 28.3922C30.367 26.2149 28.2553 24.447 25.826 23.2289C23.3967 22.0107 20.7167 21.376 17.9992 21.3752C15.2816 21.3743 12.6012 22.0073 10.1711 23.2238C7.74103 24.4404 5.62818 26.207 4.00049 28.3832C5.61986 30.5705 7.72922 32.3479 10.1594 33.573C12.5897 34.798 15.2731 35.4366 17.9946 35.4374C20.7162 35.4383 23.4 34.8015 25.831 33.578C28.262 32.3545 30.3725 30.5785 31.9933 28.3922Z" fill="#375F94"/>
<path d="M18 19.125C21.7279 19.125 24.75 16.1029 24.75 12.375C24.75 8.64708 21.7279 5.625 18 5.625C14.2721 5.625 11.25 8.64708 11.25 12.375C11.25 16.1029 14.2721 19.125 18 19.125Z" fill="#375F94"/>
</g>
<defs>
<clipPath id="clip0_2154_528">
<rect width="36" height="36" fill="white"/>
</clipPath>
</defs>
</svg>`
export const initAddParticipantMenuEvent=() => {
    const menu=$('<div/>',{
        class:'menu-items chat-participants-list',
        html:`No results found.`
    });
    tippy(document.getElementById('chat_add_participant_action'),{
        content:menu,
        trigger: 'click',
        placement: 'bottom-end',
        allowHTML: true,
        theme:'light',
        arrow:false,
        zIndex: 1020,
        interactive:true,
        hideOnClick: false,
        maxWidth: 360,
        offset: [41, 10],
        appendTo: () => document.body,
        onShow(instance) {
            renderAddParticipantMenu()
        }
    });
}


const renderAddParticipantMenu = () => {
    const tippyInstance = document.getElementById('chat_add_participant_action')?._tippy;
    const activeChat = chat.getGroupChatById(chat.selectedChatId);
    console.log("The active chat", activeChat)
    const privateChat = activeChat?.members?.length <= 2;
    // const participants = getAvailableParticipantsToChat().map((pId) => {
    //     return {
    //         id: pId,
    //         name: chat.getParticipantDisplayName(pId)
    //     }
    // });
    const menuItems=$('<div/>',{
        class:'menu-items chat-participants-list',
        html: []
    });
    let selectedItems = [];
    const searchInput = $('<input/>',{
        type: 'text',
        maxlength: 100,
        placeholder: 'Enter a name'
    }).on('input', (e) => {
        debounceSearch(menuItems,e.target.value,selectedItems,addMemberItem);
    });

    const tsControl=$("<div/>",{
        class:'search-control',
        html: searchInput
    })
    const addMemberItem=(item)=>{
        const removeItem=$("<span/>",{
            class:'remove',
            html:'×',
            title:'Remove participant',
            tabindex:'-1'
        }).on('click',() => {
            removeMemberItem(item);
        })
        const memberItem=$('<div/>',{
            class:'item',
            memberid:item.id,
            html:[item.name,removeItem]
        })

        tsControl.find('input').before(memberItem);
        selectedItems.push(item);
        renderParticipantsBySearch(menuItems,'',selectedItems,addMemberItem);
    }

    const removeMemberItem = (item)=>{
        selectedItems = selectedItems.filter(i=>i.id !== item.id);
        tsControl.find(`.item[memberid=${item.id}]`).remove();
        renderParticipantsBySearch(menuItems,'',selectedItems,addMemberItem);
    }
    const searchContainer = $("<div/>", {
        class: 'search-container position-relative w-100',
        html: tsControl
    })
    const modalHeader=$('<div/>',{
        class:'tippy-modal-header w-100 d-flex align-items-center mb-2',
        html:`<span class="tippy-modal-title">${ privateChat ? 'Start a group chat' : 'Add people to chat'}</span>`

    })

    const createButton = $('<div/>',{
        class:'btn btn-primary kino-btn-primary tippy-modal-custom-btn py-2',
        html:privateChat ? 'CREATE' : 'ADD PEOPLE',
    })

    const cancelButton = $('<div/>',{
        class:'btn btn-primary kino-btn-secondary',
        html:'CANCEL'
    }).on('click',() => {
        tippyInstance.hide();
    })

    const footer = $('<div/>',{
        class:'tippy-modal-footer w-100 d-flex justify-content-end mt-2',
        html:[cancelButton,createButton]
    })

    renderParticipantsBySearch(menuItems,'',selectedItems,addMemberItem);

    const menuContent = $('<div/>',{
        class: 'menu-content members-list',
        html:[
            modalHeader,
            searchContainer,
            [`<div class="chats-divider mb-0 mx-0 w-100"></div>`],
            menuItems,
            footer
        ]
    });
    tippyInstance && tippyInstance.setContent(menuContent[0]);

    createButton.on('click',() => {
        if(selectedItems.length > 0){
            if(privateChat){
                const currentMemebers= activeChat.members.map((m) => m.guest_id);
                console.log("Selected items", selectedItems);
                const selectedMemberIds = [...new Set([...currentMemebers,...selectedItems.map((s) => s.id)])];
                const mappedParticipants = selectedMemberIds.map((p) => {
                    return {
                        guest_id: p,
                        displayName: chat.getParticipantDisplayName(p),
                    }
                });
                console.log("Mapped participants", mappedParticipants);
                // return
                createGroupChatFromMenu(mappedParticipants).then((newChat) => {
                    tippyInstance.hide();
                }).catch((err) => {
                    console.log(err);
                })
            }else{
                console.log("Selected items", selectedItems);
                const selectedMemberIds = [...new Set([...selectedItems.map((s) => s.id)])];
                const mappedParticipants = selectedMemberIds.map((p) => {
                    return {
                        guest_id: p,
                        displayName: chat.getParticipantDisplayName(p),
                    }
                });
                console.log("Mapped participants", mappedParticipants);
                // return
                addMembersFromMenu(activeChat.id,mappedParticipants).then((newChat) => {
                    tippyInstance.hide();
                }).catch((err) => {
                    console.log(err);
                })
            }
        }else{
            //please select a participant
        }
    })
}

const getAvailableParticipants = (filter="")=>{
    if(chat.provider){
        return chat.provider.getAvailableParticipantsToChat(filter)
    }
    return getAvailableParticipantsToChat(filter).map((pId) => {
        return {
            id: pId,
            name: chat.getParticipantDisplayName(pId)
        }
    })
}

const renderParticipantsBySearch=(container,filter,selected,addFunction)=>{
    const selectedIds = selected.map((s) => s.id);
    const participants = getAvailableParticipants(filter).filter((p) => !selectedIds.includes(p.id));

    container.html(participants.length === 0 ? `<div class="w-100 py-4 text-center">No results to show.</div>` : '')

    participants.forEach((p) => {
        const menuItem=$('<div/>',{
            class:'menu-item',
            html:[AVATAR_ICON,p.name]
        });
        menuItem.on('click',() => {
            addFunction(p);
        });
        container.append(menuItem);
    });
}

const debounceSearch = debounce(renderParticipantsBySearch, 200);
